// Top Navigation
import React, { Component } from 'react'
import TopNavBar from '../components/TopNavBar'
import UserMenuItem from './UserMenuItem'
import NotificationsMenuItem from './NotificationsMenuItem'

class Top extends Component {
  render () {
    return (
      <div className="top_nav">
        <nav>
          <div className="nav toggle">
            <a id="menu_toggle" style={{display: "none"}}><i className="fa fa-bars"></i></a>
          </div>
        </nav>
      </div>
    )
  }
}

export default Top